/*
 * 戒导航 · 知识库审核（jiedh/wiki-review）—— 前台扩展声明
 *
 * 设计依据：doc/知识库内容审核设计方案.md §7.3。
 *
 * 为什么必须注册（而不是"后端发了通知前端自然就会显示"）：
 *   vendor/flarum/core/js/src/forum/components/NotificationType.tsx 的渲染逻辑是
 *       const C = app.notificationComponents[notification.contentType()];
 *       return C ? <C notification={...} /> : null;
 *   取不到组件就 **静默 return null**（不报错、不显示）—— 新通知类型必须自己注册。
 *
 * 注册方式照抄 packages/review（第 1 期已上线）与官方 flarum/likes
 * （vendor/flarum/likes/js/src/forum/extend.ts:16-17）。
 * 第一个参数是**通知类型标识**，必须与后端
 * JieDH\WikiReview\Notify\WikiArticleApprovedBlueprint::getType()（'jiedhWikiArticleApproved'）
 * 与 WikiArticleRejectedBlueprint::getType()（'jiedhWikiArticleRejected'）**逐字一致**。
 */
import Extend from 'flarum/common/extenders';
import WikiReviewReceipt from './models/WikiReviewReceipt';
import WikiReviewNotification from './components/WikiReviewNotification';
export default [
/*
 * ★ 注册「审核回执」前端模型（type = wikiReviewReceipts）。
 *
 * 为什么必须注册（漏了它 → 通知面板一片空白）：
 *   通知 API 的 relationships.subject 指向 wikiReviewReceipts 资源，而 Flarum 前端的
 *   app.store 只接收**已注册的 type**（common/Store.ts → pushObject 对未注册 type
 *   return null 并异步抛错）。未注册时该资源进不了 store ⇒
 *   notification.subject()（common/Model.ts → hasOne）拿到 undefined ⇒
 *   forum/components/NotificationList.js:82 `if (typeof subject === 'undefined') return;`
 *   直接把整条通知丢掉 —— 于是下拉面板看不到任何审核结果内容。
 *
 * 第一个参数必须与后端 WikiReviewReceiptResource::type() 的返回值（'wikiReviewReceipts'）
 * 完全一致。注册 API 见 vendor/flarum/core/js/src/common/extenders/Store.ts。
 */
new Extend.Store().add('wikiReviewReceipts', WikiReviewReceipt),
// 知识库审核结果通知（通过 = jiedhWikiArticleApproved / 驳回 = jiedhWikiArticleRejected）
new Extend.Notification().add('jiedhWikiArticleApproved', WikiReviewNotification), new Extend.Notification().add('jiedhWikiArticleRejected', WikiReviewNotification)];